import React from "react";
import clsx from "clsx";

interface StepNumberCircleProps {
  text: string;
  bgColor?: string;
  textColor?: string;
  className?: string;
}

const StepNumberCircle = ({
  text,
  bgColor = "bg-primary-100",
  textColor = "text-primary-600",
  className,
}: StepNumberCircleProps) => {
  return (
    <div
      className={clsx(
        "h-[28px] w-[28px] rounded-[100px] font-bold text-lg grid place-items-center",
        bgColor,
        textColor,
        className,
      )}
    >
      <span className="-translate-y-[0.5px] leading-none">{text}</span>
    </div>
  );
};

export default StepNumberCircle;
